import * as React from 'react';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {CopyableLink} from 'shells/link/copyable-link';
import {Popover} from 'shells/popover/popover';

type Props = {
    anchor: HTMLElement | null | undefined;
    versionA: string;
    versionB: string;
    onBlur: () => void;
};

export function ShareUrlPopover(props: Props) {
    return (
        <Popover anchor={props.anchor} location='bottom-left' onBlur={props.onBlur}>
            <div style={{padding: 24}}>
                <StackLegacy spacing={24}>
                    <CopyableLink
                        name='versionA'
                        label={props.versionB ? 'Version A' : undefined}
                        value={props.versionA}
                        size='big'
                        isLinkClickable={true}
                    />
                    {props.versionB ? (
                        <CopyableLink
                            name='versionB'
                            label='Version B'
                            value={props.versionB}
                            size='big'
                            isLinkClickable={true}
                        />
                    ) : undefined}
                </StackLegacy>
            </div>
        </Popover>
    );
}
